import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { GuidesService } from '@appStore/help/services/guides.service';
import { ActionTypes } from '@appStore/help/actions';
import * as actions from '@appStore/help/actions';

@Injectable()
export class GuidesEffects {
  constructor(private guidesService: GuidesService, private actions$: Actions) {}

  loadGuides$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.GuidesLoad),
      exhaustMap(action => {
        return this.guidesService.getGuides().pipe(
          map(guides => new actions.GuidesLoadSuccess(guides)),
          catchError(error => of(new actions.GuidesLoadFail(error)))
        );
      })
    );
  });
}
